 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","campaigns/blocked-clients":"campaigns/blocked-clients","campaigns~messages~team~templates~users":"campaigns~messages~team~templates~users","messages":"messages","team":"team","users":"users","invite.sellia":"invite.sellia","campaigns":"campaigns","dashboard":"dashboard","templates":"templates","styleguide":"styleguide","campaigns/assign-users":"campaigns/assign-users","company":"company","configuration":"configuration","dashboard/settings":"dashboard/settings","notifications":"notifications"}[chunkId]||chunkId) + "." + {"404":"4edecc3f","campaigns/blocked-clients":"1abb4f54","campaigns~messages~team~templates~users":"60c6ebbf","messages":"f60a11c5","team":"6d31f4a0","users":"19f51663","chunk-1b24c449":"ad8b08df","chunk-3dea25de":"9b9ac5a9","chunk-6b7297ba":"24693032","chunk-13ffb1d8":"9f32afa0","chunk-064554d2":"0200f9e7","invite.sellia":"d318506e","chunk-6e83591c":"43f6310a","chunk-67cd859d":"365bafe2","chunk-82db9f8c":"62e93fcc","chunk-0940b4b3":"f95fd6f7","chunk-8e260bcc":"83a6fcb4","chunk-1f6af950":"bfaf81f0","campaigns":"300953ef","dashboard":"5933655c","chunk-d9be5ef0":"0be55cf3","chunk-8fe7578e":"2b79ac7a","chunk-4b374f6e":"733e13e7","chunk-dab2a11e":"4c06e483","templates":"70f86b58","styleguide":"6eddbaba","campaigns/assign-users":"df8c7235","company":"35ddd28b","configuration":"bdf1315e","dashboard/settings":"71de0a00","notifications":"e12da98b","chunk-04eeff2d":"7ea6f3b6","chunk-415d9342":"366ca295","chunk-2d21648f":"dce6ed55","chunk-5bf2bb31":"adb4caf4","chunk-65d46fda":"9fc29c7a","chunk-4009dbb7":"cecbb3e0","chunk-67c6ae4a":"bc335ef3","chunk-2d0dab32":"2ba4df78","chunk-2d20f706":"59903353","chunk-34fba2c0":"ff274916","chunk-a4df2236":"b1633ec6","chunk-6f80cbfa":"af9c5203","chunk-40bd8cb4":"76717e40","chunk-cd29d46c":"399f1d16","chunk-6a2d984c":"30199dcb","chunk-2d0b92b2":"d8ce3da8","chunk-8c40dfca":"029fde78","chunk-2154818c":"7d0166b0","chunk-79642c4e":"96aa8edb","chunk-4bc6d2fd":"97f609c7","chunk-064e0ffa":"e0a6d77d","chunk-25190b22":"6706a045","chunk-5e49c8f2":"71c9f04f","chunk-659fce2c":"47570756","chunk-e3220108":"97fcb07d","chunk-2e2409dd":"0bd02281","chunk-77e0d4a5":"84bae626","chunk-b6a54cd6":"6944d916","chunk-02d80548":"034289ab","chunk-3de62b60":"3e99a5dc","chunk-561981b2":"7fa1cdd4","chunk-57437f7a":"367a08f2","chunk-72a98288":"9eec3fb8","chunk-bd4372e4":"1ec93c7e","chunk-40b2f6f6":"afcb861d","chunk-6994231e":"69b3b587","chunk-215851cc":"88b5b96d","chunk-2d654132":"3f33e63d","chunk-7efdd45e":"1932ba0f","chunk-41036cae":"cff57a65","chunk-8ac62116":"3c120f0c","chunk-23313127":"b829f0a6","chunk-77f47ba8":"1630f4d4","chunk-04dd4ca6":"249e82a3","chunk-6a9c7c40":"b76d7155","chunk-7c69d3f7":"9b253b32","chunk-2d22949f":"d1f7d905","chunk-33507814":"bef7a18b","chunk-4f73c3bb":"8deb12ac","chunk-2d21a9c5":"25725b7e","chunk-0fbe5bca":"321d8ed0","chunk-2d0c72f7":"5c413cd6","chunk-2d0cc97a":"8aa385fc","chunk-466e9c51":"f51703ed","chunk-6f869744":"2d6c8a41","chunk-66b4bc0f":"2484321f","chunk-6fe5d51e":"4001e24f","chunk-756c25e0":"ffde4862","chunk-9927759e":"7d8cf4ac","chunk-9b6d36cc":"97428144","chunk-73cf819c":"71a5669f","chunk-2c6be9a4":"6ec5a8a6","chunk-58a50b2e":"43345f0b","chunk-db090b42":"910fc797","chunk-76bc820c":"b66d0473","chunk-5b17a49c":"fcab9cd3","chunk-f7db992e":"5f9c8620","chunk-0548bd92":"c72ad2d6","chunk-3fce7d40":"8c781175","chunk-4e7a42c4":"14ce58ec","chunk-165bf8d7":"d09c8f92","chunk-0514fcfc":"1580beb1","chunk-2d216f97":"70d6eb1f","chunk-7c5fd706":"850cee49","chunk-0331f0ca":"6ab40e1d","chunk-45e5bba8":"6fbdba51","chunk-2f4764e7":"bf9370e7","chunk-4825fe98":"e5e49505","chunk-48d7c632":"c2f726af","chunk-495020f0":"b0692752","chunk-692179c6":"95582767","chunk-7b173118":"6b50af6d","chunk-13354eb5":"c0c7d683","chunk-f4adb1b8":"c2a628e3","chunk-466b2a5c":"223413a2"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"404":1,"campaigns~messages~team~templates~users":1,"messages":1,"team":1,"users":1,"chunk-1b24c449":1,"chunk-3dea25de":1,"chunk-6b7297ba":1,"chunk-13ffb1d8":1,"chunk-064554d2":1,"invite.sellia":1,"chunk-67cd859d":1,"chunk-82db9f8c":1,"chunk-0940b4b3":1,"chunk-8e260bcc":1,"chunk-1f6af950":1,"campaigns":1,"dashboard":1,"chunk-d9be5ef0":1,"chunk-8fe7578e":1,"chunk-4b374f6e":1,"chunk-dab2a11e":1,"templates":1,"campaigns/assign-users":1,"company":1,"configuration":1,"dashboard/settings":1,"notifications":1,"chunk-415d9342":1,"chunk-5bf2bb31":1,"chunk-65d46fda":1,"chunk-4009dbb7":1,"chunk-67c6ae4a":1,"chunk-34fba2c0":1,"chunk-a4df2236":1,"chunk-6f80cbfa":1,"chunk-40bd8cb4":1,"chunk-cd29d46c":1,"chunk-6a2d984c":1,"chunk-8c40dfca":1,"chunk-79642c4e":1,"chunk-4bc6d2fd":1,"chunk-25190b22":1,"chunk-659fce2c":1,"chunk-e3220108":1,"chunk-2e2409dd":1,"chunk-b6a54cd6":1,"chunk-02d80548":1,"chunk-3de62b60":1,"chunk-561981b2":1,"chunk-57437f7a":1,"chunk-72a98288":1,"chunk-bd4372e4":1,"chunk-40b2f6f6":1,"chunk-6994231e":1,"chunk-215851cc":1,"chunk-2d654132":1,"chunk-7efdd45e":1,"chunk-41036cae":1,"chunk-8ac62116":1,"chunk-23313127":1,"chunk-04dd4ca6":1,"chunk-6a9c7c40":1,"chunk-7c69d3f7":1,"chunk-33507814":1,"chunk-4f73c3bb":1,"chunk-0fbe5bca":1,"chunk-466e9c51":1,"chunk-6fe5d51e":1,"chunk-756c25e0":1,"chunk-9927759e":1,"chunk-9b6d36cc":1,"chunk-73cf819c":1,"chunk-2c6be9a4":1,"chunk-58a50b2e":1,"chunk-db090b42":1,"chunk-76bc820c":1,"chunk-5b17a49c":1,"chunk-f7db992e":1,"chunk-0548bd92":1,"chunk-3fce7d40":1,"chunk-4e7a42c4":1,"chunk-165bf8d7":1,"chunk-0514fcfc":1,"chunk-7c5fd706":1,"chunk-0331f0ca":1,"chunk-45e5bba8":1,"chunk-2f4764e7":1,"chunk-4825fe98":1,"chunk-48d7c632":1,"chunk-495020f0":1,"chunk-692179c6":1,"chunk-7b173118":1,"chunk-13354eb5":1,"chunk-f4adb1b8":1,"chunk-466b2a5c":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","campaigns/blocked-clients":"campaigns/blocked-clients","campaigns~messages~team~templates~users":"campaigns~messages~team~templates~users","messages":"messages","team":"team","users":"users","invite.sellia":"invite.sellia","campaigns":"campaigns","dashboard":"dashboard","templates":"templates","styleguide":"styleguide","campaigns/assign-users":"campaigns/assign-users","company":"company","configuration":"configuration","dashboard/settings":"dashboard/settings","notifications":"notifications"}[chunkId]||chunkId) + "." + {"404":"03e35efb","campaigns/blocked-clients":"31d6cfe0","campaigns~messages~team~templates~users":"235dd7db","messages":"9cd688c6","team":"b890bce7","users":"9964dae2","chunk-1b24c449":"77dccc39","chunk-3dea25de":"d97253ff","chunk-6b7297ba":"e3fc1cbd","chunk-13ffb1d8":"b80dedcb","chunk-064554d2":"403c26fe","invite.sellia":"9d81c50e","chunk-6e83591c":"31d6cfe0","chunk-67cd859d":"22a47ddf","chunk-82db9f8c":"e827c774","chunk-0940b4b3":"10c05544","chunk-8e260bcc":"3080dc4e","chunk-1f6af950":"0c71d539","campaigns":"87b03010","dashboard":"32f1d300","chunk-d9be5ef0":"0c3fb234","chunk-8fe7578e":"2b54876e","chunk-4b374f6e":"743d79ce","chunk-dab2a11e":"bf3697c2","templates":"7c77b4a6","styleguide":"31d6cfe0","campaigns/assign-users":"306f1c6a","company":"c78ce790","configuration":"adc6f465","dashboard/settings":"3b802b76","notifications":"d066e152","chunk-04eeff2d":"31d6cfe0","chunk-415d9342":"f3f7f5a5","chunk-2d21648f":"31d6cfe0","chunk-5bf2bb31":"520b8a25","chunk-65d46fda":"be8235bb","chunk-4009dbb7":"56c5f9cd","chunk-67c6ae4a":"beb2b14b","chunk-2d0dab32":"31d6cfe0","chunk-2d20f706":"31d6cfe0","chunk-34fba2c0":"1e515bc5","chunk-a4df2236":"3da64525","chunk-6f80cbfa":"bd53c2ea","chunk-40bd8cb4":"5b450094","chunk-cd29d46c":"c11216fe","chunk-6a2d984c":"16b30759","chunk-2d0b92b2":"31d6cfe0","chunk-8c40dfca":"59a8006d","chunk-2154818c":"31d6cfe0","chunk-79642c4e":"a92bc6cf","chunk-4bc6d2fd":"fb2a4ce0","chunk-064e0ffa":"31d6cfe0","chunk-25190b22":"365aeb53","chunk-5e49c8f2":"31d6cfe0","chunk-659fce2c":"d091dc8b","chunk-e3220108":"d235f96f","chunk-2e2409dd":"8282936a","chunk-77e0d4a5":"31d6cfe0","chunk-b6a54cd6":"13db2f55","chunk-02d80548":"a385de40","chunk-3de62b60":"d8c8db9d","chunk-561981b2":"89fa7e9e","chunk-57437f7a":"aa4048ef","chunk-72a98288":"d18dedc3","chunk-bd4372e4":"795d03c7","chunk-40b2f6f6":"3dbb0267","chunk-6994231e":"6456f67a","chunk-215851cc":"5e193930","chunk-2d654132":"9f96d6a3","chunk-7efdd45e":"09c86ec5","chunk-41036cae":"71533e70","chunk-8ac62116":"22a1034b","chunk-23313127":"ebca457a","chunk-77f47ba8":"31d6cfe0","chunk-04dd4ca6":"77cd4bf8","chunk-6a9c7c40":"020237aa","chunk-7c69d3f7":"13989977","chunk-2d22949f":"31d6cfe0","chunk-33507814":"37b10440","chunk-4f73c3bb":"2e2f325c","chunk-2d21a9c5":"31d6cfe0","chunk-0fbe5bca":"56b7a09a","chunk-2d0c72f7":"31d6cfe0","chunk-2d0cc97a":"31d6cfe0","chunk-466e9c51":"4499a4ec","chunk-6f869744":"31d6cfe0","chunk-66b4bc0f":"31d6cfe0","chunk-6fe5d51e":"6078d46a","chunk-756c25e0":"7c92248a","chunk-9927759e":"7b4c5c4b","chunk-9b6d36cc":"34301b7a","chunk-73cf819c":"7fbe9da8","chunk-2c6be9a4":"838fca75","chunk-58a50b2e":"1dd2e380","chunk-db090b42":"10266147","chunk-76bc820c":"77536837","chunk-5b17a49c":"d847ae96","chunk-f7db992e":"d217235a","chunk-0548bd92":"2b81318e","chunk-3fce7d40":"21ba8ac1","chunk-4e7a42c4":"ed4c8dd3","chunk-165bf8d7":"5a2e6643","chunk-0514fcfc":"96b51919","chunk-2d216f97":"31d6cfe0","chunk-7c5fd706":"2da7146c","chunk-0331f0ca":"f4b2a7a8","chunk-45e5bba8":"34c95f05","chunk-2f4764e7":"e40dfe5e","chunk-4825fe98":"5ecaa894","chunk-48d7c632":"76d98834","chunk-495020f0":"1d67003f","chunk-692179c6":"87e9de63","chunk-7b173118":"4d084320","chunk-13354eb5":"d506786d","chunk-f4adb1b8":"f8762af3","chunk-466b2a5c":"a8951bfd"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
